export const removeNullKeys = <T>(obj: T): Partial<T> =>
  Object.entries(obj).reduce(
    (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
    {},
  );
